import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';

export const teaAndSnacksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addScannedData: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.VENDOR.ADDSCANNEDDATA}`,
        method: `POST`,
        body: data,
      }),
      invalidatesTags: [{ type: 'Refreshments' }],
    }),
    addSnacks: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.VENDOR.ADDSNACKS}`,
        method: `POST`,
        body: data,
      }),
      invalidatesTags: [{ type: 'Refreshments' }],
    }),
    getScannedDataByDate: builder.query({
      query: ({ floor, region }) => ({
        url: `${ENDPOINTS.VENDOR.GETSCANNEDDATABYDATE}?floor=${floor}&region=${region}`,
        method: `GET`,
      }),
      providesTags: [{ type: 'Refreshments' }],
    }),
    getDataOfDateRange: builder.query({
      query: ({ from, to, region }) => ({
        url: `${ENDPOINTS.VENDOR.GETDATAOFDATERANGE}?from=${from}&to=${to}&region=${region}`,
        method: `GET`,
      }),
      providesTags: [{ type: 'Refreshments' }],
    }),
    getSnacks: builder.query({
      query: () => ({
        url: `${ENDPOINTS.VENDOR.GETSNACKS}`,
        method: `GET`,
      }),
      providesTags: [{ type: 'Refreshments' }],
    }),
    addConfig: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.REFERSHMENTS.ADDCONFIG}`,
        method: `POST`,
        body: data,
      }),
      invalidatesTags: [{ type: 'Refreshments' }],
    }),
    getConfig: builder.query({
      query: ({ region }) => ({
        url: `${ENDPOINTS.REFERSHMENTS.GETCONFIG}?region=${region}`,
        method: `GET`,
      }),
      providesTags: [{ type: 'Refreshments' }],
    }),
    getScannedDataByEmpId: builder.query({
      query: ({ empId, region }) => ({
        url: `${ENDPOINTS.REFERSHMENTS.GETSCANNEDDATABYEMPID}?empId=${empId}&region=${region}`,
        method: `GET`,
      }),
    }),
    getAttendance: builder.query({
      query: ({ date }) => ({
        url: `${ENDPOINTS.ATTENDANCE.GETATTENDANCE}?date=${date}`,
        method: `GET`,
      }),
    }),
    addAttendance: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.ATTENDANCE.ADDATTENDANCE}`,
        method: `POST`,
        body: data,
      }),
    }),
    addReview: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.REFERSHMENTS.ADDREVIEW}`,
        method: `POST`,
        body: data,
      }),
    }),
    getReviewByEmpId: builder.query({
      query: ({ empId, date }) => ({
        url: `${ENDPOINTS.REFERSHMENTS.GETREVIEWBYEMPID}?empId=${empId}&date=${date}`,
        method: `GET`,
      }),
    }),
    getReviewByDateRange: builder.query({
      query: ({ from, to,region }) => ({
        url: `${ENDPOINTS.REFERSHMENTS.GETREVIEWBYDATERANGE}?from=${from}&to=${to}&region=${region}`,
        method: `GET`,
      }),
    }),
    addVote: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.REFERSHMENTS.ADDVOTE}`,
        method: `POST`,
        body: data,
      }),
    }),
    getVote: builder.query({
      query: ({ empId, date, region }) => ({
        url: empId
          ? `${ENDPOINTS.REFERSHMENTS.GETVOTE}?empId=${empId}&date=${date}`
          : `${ENDPOINTS.REFERSHMENTS.GETVOTE}?date=${date}&region=${region}`,
        method: `GET`,
      }),
    }),
    getRegionSnacks: builder.query({
      query: ({ date, region }) => ({
        url: `${ENDPOINTS.VENDOR.GERREGIONSNACKS}?date=${date}&region=${region}`,
        method: `GET`,
      }),
    }),
    addRegionSnacks: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.VENDOR.ADDREGIONSNACKS}`,
        method: `POST`,
        body: data,
      }),
    }),
    getRegionByEmpId: builder.query({
      query: ({ empId}) => ({
        url: `${ENDPOINTS.REFERSHMENTS.GETREGIONBYEMPID}?empId=${empId}`,
        method: `GET`,
      }),
    }),
  }),
});

export const {
  useAddScannedDataMutation,
  useGetScannedDataByDateQuery,
  useGetDataOfDateRangeQuery,
  useAddSnacksMutation,
  useGetSnacksQuery,
  useAddConfigMutation,
  useGetConfigQuery,
  useGetScannedDataByEmpIdQuery,
  useGetAttendanceQuery,
  useAddAttendanceMutation,
  useAddReviewMutation,
  useGetReviewByDateRangeQuery,
  useGetReviewByEmpIdQuery,
  useAddVoteMutation,
  useGetVoteQuery,
  useGetRegionSnacksQuery,
  useAddRegionSnacksMutation,
  useGetRegionByEmpIdQuery
} = teaAndSnacksApiSlice;
